<script setup lang="ts">
import { computed, ref } from "vue";

const studentName = ref("Ali");
const studentMarks = ref("87");

const codePreview = computed(() =>
  `name = "${studentName.value}"\nmarks = ${studentMarks.value || 0}\nprint("Name:", name)\nprint("Marks:", marks)`,
);

const outputPreview = computed(() => [
  `Name: ${studentName.value || ""}`,
  `Marks: ${studentMarks.value || 0}`,
]);
</script>

<template>
  <section id="input-output-playground" class="scroll-mt-24 rounded-3xl border border-slate-200 bg-white p-5 dark:border-slate-800 dark:bg-slate-900">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900 dark:text-white">Jo likho, woh screen par kaise aata hai?</h2>
      <p class="text-sm text-slate-600 dark:text-slate-300">Naam aur marks badlo, phir dekho Python unhen screen par kaise dikhata hai.</p>
    </div>

    <div class="mt-5 grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
      <div class="grid gap-3">
        <label class="space-y-2">
          <span class="text-sm font-medium text-slate-700 dark:text-slate-200">Bache ka naam</span>
          <input
            v-model="studentName"
            type="text"
            class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none focus:border-sky-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100"
          >
        </label>

        <label class="space-y-2">
          <span class="text-sm font-medium text-slate-700 dark:text-slate-200">Marks</span>
          <input
            v-model="studentMarks"
            type="number"
            class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none focus:border-sky-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100"
          >
        </label>

        <div class="rounded-2xl border border-amber-200 bg-amber-50 p-4 dark:border-amber-900/40 dark:bg-amber-950/20">
          <p class="text-xs font-semibold uppercase tracking-[0.18em] text-amber-700 dark:text-amber-300">Yaad rakho</p>
          <p class="mt-2 text-sm leading-6 text-slate-700 dark:text-slate-200">Pehle cheez variable me jati hai. Phir `print()` us cheez ko screen par dikhata hai.</p>
        </div>
      </div>

      <div class="grid gap-4">
        <div class="rounded-2xl bg-slate-950 p-4 text-xs leading-6 text-slate-100">
          <p class="mb-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-sky-200">Python kya likhega</p>
          <pre class="overflow-x-auto"><code>{{ codePreview }}</code></pre>
        </div>

        <div class="rounded-2xl border border-emerald-200 bg-emerald-50 p-4 dark:border-emerald-900/40 dark:bg-emerald-950/20">
          <p class="text-[11px] font-semibold uppercase tracking-[0.18em] text-emerald-700 dark:text-emerald-300">Screen par kya dikhega</p>
          <div class="mt-3 space-y-1 font-mono text-sm text-slate-900 dark:text-slate-100">
            <p v-for="line in outputPreview" :key="line">{{ line }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
